/**
 * 判断是否Gen2Yuli
 * @param tokne_id
 * @returns
 */
export const checkIsGen2 = (token_id) => {
  return token_id > 200000000;
};
